import React from "react";
import {Delete} from "@mui/icons-material";

import {createUseStyles} from "react-jss";

const useStyles = createUseStyles(({colors}) => ({
    removeButton: {
        backgroundColor: colors.adminBlue,
        color: colors.white,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "16px",
        width: "24px",
        height: "24px",
        border: "none",
        padding: 0,
        "&:hover": {color: `${colors.white}aa`},
        cursor: "pointer",
        position: "absolute",
        top: "-13px",
        right: "-11px",
        zIndex: 10,
        outline: "none",
        "&::before": {
            content: '""',
            position: "absolute",
            top: -10,
            left: -10,
            right: -10,
            bottom: -10,
        },
        "&:focus-visible": {
            outline: "2px solid #4484F1",
            outlineOffset: "2px",
        },
    },
}));

export const RemoveBlockButton = ({blockId, onRemove}) => {
    const classes = useStyles();

    const handleRemove = (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        onRemove(blockId);
    };

    return (
        <button
            type="button"
            className={classes.removeButton}
            onClick={handleRemove}
            onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            aria-label="Slett blokk"
        >
            <Delete
                sx={{
                    width: "14px",
                    height: "14px",
                }}
            />
        </button>
    );
};
